<template>
  <el-tabs value="第1轮谈判">
    <el-tab-pane
      v-for="(item, index) in list"
      :label="`第${index + 1}轮谈判`"
      :name="`第${index + 1}轮谈判`"
      :key="index"
    >
      <el-form label-width="130px">
        <!-- 新增谈判发起时间 -->
        <el-form-item label="谈判发起时间：">
          <el-date-picker
            v-model="item.negoStartTime"
            type="datetime"
            placeholder="选择时间"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="谈判截止时间：">
          <el-date-picker
            v-model="item.negoEndTime"
            type="datetime"
            value-format="timestamp"
            disabled
          >
          </el-date-picker>
          <!-- 未到截止时间但供应商都已回复则本轮结束且给出提示 -->
          <span class="early-tip" v-if="item.supplierNegoEndTime">由于供应商已全部回复，本轮谈判已于
            {{ item.supplierNegoEndTime && dayjs(item.supplierNegoEndTime).format('YYYY-MM-DD HH:mm:ss') }}
            提前结束。</span>
        </el-form-item>
        <el-form-item label="采购人谈判说明：">
          <el-input
            disabled
            type="textarea"
            v-model="item.negoExplain"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商回复：">
          <div>
            <span :class="[`tanpanStatus-${item.negoStatus}`]">{{getStatusText(item.negoStatus)}}</span>
            {{
              item.negoBackTime &&
                dayjs(item.negoBackTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </div>
          <el-input
            disabled
            type="textarea"
            v-model="item.backRemark"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商的谈判报价文件：" label-width="180px">
          <zsFileDownload v-if="item.baoJiaFileGroupGuid" :fileId="item.baoJiaFileGroupGuid"/>
          <span v-else>无</span>
        </el-form-item>
      </el-form>
      <!-- 只有接受谈判的时候才调用 -->
      <template v-if="item.negoStatus === 1">
        <div class="m-b">
          总报价（含税）：<span style="color: #FF8B26">{{ item.tpPrice }}元</span> 计算规则：报价清单含税总价之和
        </div>
        <zl-server-page-table
          :api="(args) => getApi(args,item)"
          :border="false"
          height="390px"
          v-if="loaded"
          smallPagination
          paginationLayout="total, sizes, prev, pager, next, jumper"
        >
          <el-table-column
            v-for="(row, index) in listColumns"
            :key="index"
            :label="row.columnNameCH"
            :prop="row.columnNameEN"
          >
          </el-table-column>
        </zl-server-page-table>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import store from '@/store'
import zsFileDownload from '@/components/zsFileDownload'
import dayjs from 'dayjs'
export default {
  components: { zsFileDownload },
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dayjs,
      list: [],
      loaded: false,
      listColumns: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      store
        .dispatch('getGysNegoBackInfo', {
          supplierId: this.row.id
        })
        .then((res) => {
          this.list = res
        })
      store
        .dispatch('getXdColumn', {
          inquireId: this.row.inquireId
        })
        .then((res) => {
          this.listColumns = JSON.parse(res.colValue || '[]')
          this.loaded = true
        })
    },
    getApi(args, item) {
      return store
        .dispatch('pageTpJlZSInventory', {
          pageNum: args.page,
          pageSize: args.size,
          unionId: this.row.id,
          negoNo: item.negoNo
        })
        .then((res) => ({
          rows: res.list.map((t) => {
            let row = (t.rowValue && JSON.parse(t.rowValue)) || {}
            row.id = t.id
            return row
          }),
          total: res.totalCount
        }))
    },
    getStatusText(val) {
      switch (val) {
        case 0:
          return '未回复'
        case 1:
          return '接受谈判'
        case 2:
          return '拒绝谈判'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@each $key, $value in $tanpanStatus {
  .tanpanStatus-#{$key}{
    color: $value;
    font-size: 16px;
    font-weight: bold;
  }
}
.early-tip {
  padding-left: 8px
}
</style>
